// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Timer-cls1__ea8dec1b7bfa03076df4{/*!*/}.Timer-cls2__b520e7a17dcadb015476{position:absolute;left:0;margin:auto;right:0;text-align:center}.Timer-cls2__b520e7a17dcadb015476.Timer-top___74c40d2f55c4191ac67{top:50%}.Timer-cls2__b520e7a17dcadb015476.Timer-topBack___400226856d80a90aa5a{top:60%;transform:scaleY(-1)}.Timer-cls2__b520e7a17dcadb015476.Timer-bottom___74bc4a94a72c9c60a12{top:-50%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Timer-cls1__ea8dec1b7bfa03076df4",
	"cls2": "Timer-cls2__b520e7a17dcadb015476 Timer-cls1__ea8dec1b7bfa03076df4",
	"top": "Timer-top___74c40d2f55c4191ac67",
	"topBack": "Timer-topBack___400226856d80a90aa5a",
	"bottom": "Timer-bottom___74bc4a94a72c9c60a12"
};
export default ___CSS_LOADER_EXPORT___;
